/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { slackDirectoryConnectionsListMembers } from "../funcs/slackDirectoryConnectionsListMembers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListMembersResponseBody } from "../models/components/listmembersresponsebody.js";
import {
  ListSlackDirectoryMembersRequest,
  ListSlackDirectoryMembersSecurity,
  MappingStatus,
} from "../models/operations/listslackdirectorymembers.js";
import { unwrapAsync } from "../types/fp.js";
export type SlackDirectoryMembersQueryData = ListMembersResponseBody;

export function prefetchSlackDirectoryMembers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSlackDirectoryMembersRequest | undefined,
  security?: ListSlackDirectoryMembersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSlackDirectoryMembersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSlackDirectoryMembersQuery(
  client$: GramCore,
  request?: ListSlackDirectoryMembersRequest | undefined,
  security?: ListSlackDirectoryMembersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SlackDirectoryMembersQueryData>;
} {
  return {
    queryKey: queryKeySlackDirectoryMembers({
      connectionId: request?.connectionId,
      search: request?.search,
      mappingStatus: request?.mappingStatus,
      includeDeactivated: request?.includeDeactivated,
      includeBots: request?.includeBots,
      includeGuests: request?.includeGuests,
      sortAsOf: request?.sortAsOf,
      page: request?.page,
      limit: request?.limit,
      gramSession: request?.gramSession,
    }),
    queryFn: async function slackDirectoryMembersQueryFn(
      ctx,
    ): Promise<SlackDirectoryMembersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(slackDirectoryConnectionsListMembers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySlackDirectoryMembers(
  parameters: {
    connectionId?: string | undefined;
    search?: string | undefined;
    mappingStatus?: MappingStatus | undefined;
    includeDeactivated?: boolean | undefined;
    includeBots?: boolean | undefined;
    includeGuests?: boolean | undefined;
    sortAsOf?: Date | undefined;
    page?: number | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "slackDirectoryConnections",
    "listMembers",
    parameters,
  ];
}
